import WinBase from "./winBase";
import {GoingUtils} from "goingutils";
import GoSingleQueryCtl from "../../../jsCom/comCtl/GoSingleQueryCtl";
import TreeDrop from "../../goForm/components/go-tree-drop";

class ShowLeftTreeRightGrid extends WinBase {
    constructor(options, vueObj) {
        super(options);
        this.options = $.extend({}, options);
        this.vueObj = vueObj;
    }

    /**
     * 激活form窗口对象
     * @param vueObj
     * @returns {*}
     */
    showWin() {
        let vueObj = this.vueObj;
        let divId = GoingUtils.getUUid(12);

        let htmlContent = `
            <div class="h100b clearfix" id='${divId}'>
                         <div  id="${divId}_tree_drop"  class="go-tree-ctl borderBox pull-left" style="border-right: 1px solid #dfdfdf;box-sizing: border-box;width:30%; ">
                            ${TreeDrop.getSearchBox(divId+"_tree")}
                             <div id='${divId}_tree'></div>
                         </div>
                          <div  id="${divId}_grid_div" class="col-sm-8 borderBox pull-left"  style="width:calc(70% - 4px);border: 0;padding-left: 2px;">
                               <div class="pull-right" id="${divId}_search_div" style="padding: 8px 15px 6px;">
                                    <div id="${divId}_search"></div>
                               </div> 
                              <div  id='${divId}_grid' style="width: 100%;height:calc(100% - 45px);"></div>
                         </div>
                </div>`;
        //弹出窗口
        this.showDialogWin(htmlContent);

        //是否存在查询
        if (this.options.hasSearch) {
            new GoSingleQueryCtl(
                divId + "_search",
                this.options.config["fieldAry"],
                vueObj,
                this.options.searchFun
            );
        }else{
            $(`#${divId}_search_div`).remove();
        }
        //初始化容器的高度
        this.initWinContainer(divId, divId + "_tree", divId + "_grid",this.options);

        //激活表格对象
        let gridObj = this.attachGridObj(divId + "_grid", vueObj);
        //如果存在初始化树的函数
        if(this.options.initGridObj){
            this.options.initGridObj(gridObj);
        }

        //激活树
        let treeObj = this.attachTreeObj(
            divId + "_tree",
            this.options.config["clickTreeNode"],
            gridObj
        );
        //初始化底部操作栏
        this.addBottomBar(divId);
        //初始化底部事件
        this.initBottomEvent({divId, goAclWin:gridObj, vueObj, treeObj});
        //如果存在初始化树的函数
        if(this.options.initTreeObj){
            this.options.initTreeObj(treeObj);
        }
    }

    //初始化容器的高度
    initWinContainer(divId, treeDivId, gridDivId,options) {
        let height = 76;

        let oldHeight = $("#" + divId).height();
        $("#" + divId).height(parseFloat(oldHeight + "") - 40);

        //设置表格的高度
        let gridHeight=oldHeight;
        //如果存在表格查询功能
        if (options.hasSearch) {
            gridHeight = parseFloat(oldHeight) - 44;
        }
        $("#" + gridDivId).height(parseFloat(gridHeight + "") - 76);

        $("#" + gridDivId)
            .closest(".layui-layer-content")
            .css("overflow", "hidden");

        $("#" + treeDivId).width(parseFloat($("#" + treeDivId).width() + "") - 3);

        if (options.hasTreeSearch) {
            oldHeight = parseFloat(oldHeight) - 30;
        }
        $("#" + treeDivId).height(parseFloat(oldHeight + "") - height + 30);

        $("#" + treeDivId)
            .closest(".layui-layer-content")
            .css("overflow", "hidden");
    }
}

export default ShowLeftTreeRightGrid;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showLeftTreeRightGrid.js